// Harshada Bhavsar (23/07/2025)
import React, { useState, useRef, useEffect } from "react";
import {
  VerifyCandidate,
  EmpSendCandidate,
} from "../Services/SendCandidateService";
import { useNavigate, useParams } from "react-router-dom";
import Cookies from "js-cookie";
import bgImage from "../../../../../Assets/bg3.jpg";
import NormalAlert from "../../../../Alerts/NormalAlert";
import ConfirmationAlert from "../../../../Alerts/ConfirmationAlert";
import SendCandidateModal from "../Modals/SendCandidateModal";
import { getJobDetails } from "../../DraftJob/Services/DraftJobService";
import JobDescriptionModal from "../../DraftJob/Modals/JobDescriptionModal";
import { getGenderType, getAllJobLocations } from "../../../../Auth/Services/metadataService";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";

const SubmitCandidate = () => {
  const requestIdRef = useRef(null);
  const navigate = useNavigate();
  const token = Cookies.get("employeeToken");
  const { jobUID } = useParams();
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    CandidateName: "",
    CandidateEmail: "",
    CandidatePhoneNo: "",
    CandidatePAN: "",
    CandidateDOB: "",
    JobUID: "",
    Token: "",
  });

  const initialFormData = {
    CandidateName: "",
    CandidateEmail: "",
    CandidatePhoneNo: "",
    CandidatePAN: "",
    CandidateDOB: "",
  };

  const [sendFormData, setSendFormData] = useState({
    CurrentCTC: "",
    ExpectedCTC: "",
    TotalExperience: "",
    CurrentLocation: "",
    NoticePeriod: "",
    ReadytoRelocate: "",
    ReasonofLeaving: "",
    Remarks: "",
    Gender: "",
    CurrentCompany: "",
    PreferredLocation: "",
    Qualification: "",
    DomainExperience: "",
    ResumeFile: null,
  });

  const [requestId, setRequestId] = useState("");
  const [showSendForm, setShowSendForm] = useState(false);

  const [errors, setErrors] = useState({});
  const [alert, setAlert] = useState(null);
  const [confirmalert, confirmsetAlert] = useState(null);
  const [showConfirm, setShowConfirm] = useState(false);
  const [isRelocateOpen, setIsRelocateOpen] = useState(false);
  const [jobDetails, setJobDetails] = useState(null);
  const [showJDModal, setShowJDModal] = useState(false);
  const [gender, setGender] = useState([]);
   const [joblocations, setJoblocations] = useState([]);

  const fetchJobDetails = async () => {
    try {
      const res = await getJobDetails(jobUID);
      setJobDetails(res.data.jobData[0]);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSendChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    if (type === "file") {
      const file = files[0];

      if (file) {
        const allowedTypes = [
          "application/pdf",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        ];

        const maxSizeMB = 5;
        const maxSizeBytes = maxSizeMB * 1024 * 1024;

        if (!allowedTypes.includes(file.type)) {
          setAlert({
            type: "fail",
            message: "Only PDF or DOCX files are allowed.",
          });
          return;
        }

        if (file.size > maxSizeBytes) {
          setAlert({
            type: "fail",
            message: `File size must not exceed ${maxSizeMB} MB.`,
          });
          return;
        }

        setSendFormData((prev) => ({
          ...prev,
          [name]: file,
        }));

        setErrors((prev) => {
          const updated = { ...prev };
          delete updated.ResumeFile;
          return updated;
        });
      }
    } else if (type === "checkbox") {
      setSendFormData({ ...sendFormData, [name]: checked });
    } else {
      setSendFormData({ ...sendFormData, [name]: value });

      setErrors((prev) => {
        const updated = { ...prev };

        // remove error if field is filled
        if (value && value.toString().trim() !== "") {
          delete updated[name];
        }

        return updated;
      });
    }
  };

  const handleSendSubmit = async (e) => {
    e.preventDefault();

    setErrors({});
    setAlert(null);

    const newErrors = {};

    if (!sendFormData.ResumeFile)
      newErrors.ResumeFile = "Resume file is required";

    // Current CTC
    if (!sendFormData.CurrentCTC) {
      newErrors.CurrentCTC = "Current CTC is required";
    } else if (!/^\d{5,}$/.test(sendFormData.CurrentCTC)) {
      newErrors.CurrentCTC = "Current CTC must be atleast 5 digits";
    }

    // Expected CTC
    if (!sendFormData.ExpectedCTC) {
      newErrors.ExpectedCTC = "Expected CTC is required";
    } else if (!/^\d{5,}$/.test(sendFormData.ExpectedCTC)) {
      newErrors.ExpectedCTC = "Expected CTC  must be atleast 5 digits";
    }

    if (!sendFormData.TotalExperience)
      newErrors.TotalExperience = "Total Experience is required";

    if (!sendFormData.CurrentLocation)
      newErrors.CurrentLocation = "Current Location is required";

    if (!sendFormData.NoticePeriod)
      newErrors.NoticePeriod = "Notice Period is required";

    if (!sendFormData.ReadytoRelocate)
      newErrors.ReadytoRelocate = "Ready to Relocate is required";

    if (!sendFormData.ReasonofLeaving)
      newErrors.ReasonofLeaving = "Reason of leaving is required";

    if (!sendFormData.Remarks) newErrors.Remarks = "Remarks are required";

    if (!sendFormData.Gender) newErrors.Gender = "Gender is required";

    if (!sendFormData.PreferredLocation)
      newErrors.PreferredLocation = "Preferred Location is required";

    if (!sendFormData.CurrentCompany)
      newErrors.CurrentCompany = "Current Company is required";

    if (!sendFormData.Qualification)
      newErrors.Qualification = "Qualification is required";

    if (!sendFormData.DomainExperience)
      newErrors.DomainExperience = "Domain Experience is required";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      const payload = {
        Token: token,
        RequestID: requestIdRef.current,
        ...sendFormData,
      };

      const res = await EmpSendCandidate(payload);

      if (res.data?.status === "Success") {
        setAlert({
          type: "success",
          message: res.data?.message || "Candidate sent.",
        });

        setShowSendForm(false);

        setSendFormData({
          CurrentCTC: "",
          ExpectedCTC: "",
          TotalExperience: "",
          CurrentLocation: "",
          NoticePeriod: "",
          ReadytoRelocate: "",
          ReasonofLeaving: "",
          Remarks: "",
          Gender: "",
          CurrentCompany: "",
          PreferredLocation: "",
          Qualification: "",
          DomainExperience: "",
          ResumeFile: null,
        });

        if (fileInputRef.current) fileInputRef.current.value = "";
      } else {
        handleBackendErrors(res.data?.message);
      }
    } catch (err) {
      const backendMessage = err.response?.data?.message || "";

      if (!handleBackendErrors(backendMessage)) {
        setAlert({
          type: "fail",
          message: backendMessage || "Error sending candidate",
        });
      }
    }
  };

  const handleBackendErrors = (message) => {
    if (!message) return false;

    setAlert({
      type: "fail",
      message: message,
    });

    return true;
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.CandidateName) {
      newErrors.CandidateName = "Candidate Name is required";
    } else {
      const name = formData.CandidateName.trim();

      // Regex: Only letters + at least one space between names
      const nameRegex = /^[A-Za-z]+(\s[A-Za-z]+)+$/;

      if (!nameRegex.test(name)) {
        newErrors.CandidateName =
          "Enter full name (First name and Last name only)";
      }
    }
    if (!formData.CandidatePhoneNo)
      newErrors.CandidatePhoneNo = "Candidate Phone No is required";

    if (!formData.CandidateEmail)
      newErrors.CandidateEmail = "Candidate Email is required";

    if (formData.CandidateDOB) {
      const dob = new Date(formData.CandidateDOB);
      const age = new Date().getFullYear() - dob.getFullYear();
      const m = new Date().getMonth() - dob.getMonth();
      if (age < 18 || (age === 18 && m < 0)) {
        newErrors.CandidateDOB = "Candidate must be 18 years or older.";
      }
    }
    const today = new Date();
    const selectedDOB = new Date(formData.CandidateDOB);
    if (selectedDOB > today) {
      newErrors.CandidateDOB = "Date of Birth cannot be in the future.";
    }
    if (!formData.CandidateDOB)
      newErrors.CandidateDOB = "Candidate DOB is required";

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const clientErrors = validateForm();
    if (Object.keys(clientErrors).length > 0) {
      setErrors(clientErrors);
      return;
    }

    try {
      const payload = {
        ...formData,
        JobUID: jobUID,
        Token: token,
      };

      const response = await VerifyCandidate(payload);
      handleVerifySuccess(response.data);
    } catch (error) {
      if (error.response && error.response.status === 409) {
        handleVerifySuccess(error.response.data);
      } else {
        setAlert({
          type: "fail",
          message:
            error?.response?.data?.message ||
            "Something went wrong. Please try again.",
        });
      }
    }
  };

  const handleVerifySuccess = (data) => {
    const rid = data.RequestID || data.requestID;

    requestIdRef.current = rid;
    setRequestId(rid);

    setErrors({});

    let dynamicTitle = "Confirmation";
    let highlightType = "normal";

    const msg = data.message?.toLowerCase() || "";

    if (msg.includes("already submitted")) {
      dynamicTitle = "Duplicate Candidate";
      highlightType = "duplicate";
    } else if (msg.includes("proceed to submit")) {
      dynamicTitle = "Fresh Candidate";
      highlightType = "fresh";
    }

    if (data.canSubmit) {
      setShowConfirm(true);
      confirmsetAlert({
        type: dynamicTitle,
        message: data.message,
        highlightType,
      });
    } else {
      setShowSendForm(true);
    }

    setFormData(initialFormData);
  };

  const handleReset = () => {
    setFormData(initialFormData);
    setErrors({});
  };

  const handleConfirm = () => {
    setShowConfirm(false);
    confirmsetAlert(null);
    setShowSendForm(true);
  };

  const handleCancel = () => {
    setShowConfirm(false);
    confirmsetAlert(null);
  };

  React.useEffect(() => {
    if (showSendForm) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showSendForm]);

  React.useEffect(() => {
    fetchJobDetails();
  }, [jobUID]);

  useEffect(() => {
    const fetchGender = async () => {
      const res = await getGenderType();

      setGender(res || []);
    };

    fetchGender();
  }, []);

   useEffect(() => {
    const fetchJobLocations = async () => {
      const res = await getAllJobLocations();

      setJoblocations(res || []);
    };

    fetchJobLocations();
  }, []);

  return (
    <>
      <div className="min-h-screen bg-[#f4f6f9]">
        {/* Banner */}
        <div
          className="w-full h-[200px] bg-cover bg-center"
          style={{ backgroundImage: `url(${bgImage})` }}
        />

        {/* Form Wrapper */}
        <div className="max-w-[1200px] mx-auto -mt-20 pb-20 px-4">
          <div className="flex gap-6">
            {/*  LEFT SIDE - JOB DETAILS */}
            <div className="w-[320px] bg-white rounded-2xl shadow-lg p-6 h-fit sticky top-6 border">
              {/* Header */}
              <div className="mb-5">
                <h3 className="text-lg font-semibold text-[#0467c5]">
                  Job Details
                </h3>
                <p className="text-xs text-gray-400">
                  Information about this position
                </p>
              </div>

              {jobDetails ? (
                <div className="space-y-4 text-sm">
                  {/* Job Title */}
                  <div>
                    <p className="text-gray-400 text-xs uppercase">Job Title</p>
                    <p className="text-gray-900">{jobDetails.jobTitle}</p>
                  </div>

                  {/* Department + Location */}
                  <div className="flex justify-between gap-2">
                    <div>
                      <p className="text-gray-400 text-xs uppercase">
                        Department
                      </p>
                      <p className="text-gray-700">{jobDetails.department}</p>
                    </div>
                  </div>

                  <div className="flex justify-between gap-2">
                    <div>
                      <p className="text-gray-400 text-xs uppercase">
                        Function
                      </p>
                      <p className="text-gray-700">{jobDetails.function}</p>
                    </div>
                  </div>

                  {/* Grade + Function */}
                  <div className="flex justify-between gap-2">
                    <div>
                      <p className="text-gray-400 text-xs uppercase">
                        Location
                      </p>
                      <p className="text-gray-700">{jobDetails.location}</p>
                    </div>
                    <div>
                      <p className="text-gray-400 text-xs uppercase">Grade</p>
                      <p className="text-gray-700">{jobDetails.grade}</p>
                    </div>
                  </div>

                  {/* Experience */}
                  <div>
                    <p className="text-gray-400 text-xs uppercase">
                      Experience
                    </p>
                    <p className="text-gray-700">
                      {jobDetails.minimumExperience}-
                      {jobDetails.maximumExperience} yrs
                    </p>
                  </div>

                  {/* Salary + Openings */}
                  <div className="flex justify-between items-center bg-gray-50 rounded-lg p-3">
                    <div>
                      <p className="text-gray-400 text-xs uppercase">Salary</p>
                      <p className="font-medium text-gray-800">
                        ₹{jobDetails.offeredSalary}
                      </p>
                    </div>

                    <div className="text-right">
                      <p className="text-gray-400 text-xs uppercase">
                        Openings
                      </p>
                      <p className="font-medium text-gray-800">
                        {jobDetails.numberOfOpenings}
                      </p>
                    </div>
                  </div>

                  {/* Button */}
                  <button
                    onClick={() => setShowJDModal(true)}
                    className="mt-3 w-full bg-primary text-white py-2.5 rounded-lg font-medium hover:shadow-md hover:scale-[1.02] transition"
                  >
                    View Job Description
                  </button>
                </div>
              ) : (
                <p className="text-gray-400 text-sm">Loading...</p>
              )}
            </div>

            {/*  RIGHT SIDE*/}
            <div className="flex-1 flex justify-end">
              <div className="w-full max-w-[800px] bg-white rounded-xl shadow-lg p-8">
                {/* Header */}
                <div className="text-center mb-6">
                  <div className="flex justify-center mb-3">
                    <svg
                      width="70"
                      height="70"
                      viewBox="0 0 24 24"
                      fill="#0467c5"
                    >
                      <circle cx="12" cy="8" r="4" />
                      <path d="M4 20c0-3.5 3.5-6 8-6s8 2.5 8 6v1H4v-1z" />
                    </svg>
                  </div>
                  <h2 className="text-2xl font-medium text-[#0467c5]">
                    Submit Candidate
                  </h2>
                </div>

                <hr className="mb-8 border-gray-300" />

                {/* FORM */}
                <form
                  onSubmit={handleSubmit}
                  className="grid grid-cols-1 md:grid-cols-2 gap-6"
                >
                  {/* Candidate Name */}
                  <div>
                    <label className="block text-sm font-medium mb-1">
                      Candidate Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="CandidateName"
                      placeholder="Candidate Name"
                      value={formData.CandidateName}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
                    />
                    {errors.CandidateName && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.CandidateName}
                      </p>
                    )}
                  </div>

                  {/* Email */}
                  <div>
                    <label className="block text-sm font-medium mb-1">
                      Candidate Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="CandidateEmail"
                      placeholder="Candidate Email"
                      value={formData.CandidateEmail}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
                    />
                    {errors.CandidateEmail && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.CandidateEmail}
                      </p>
                    )}
                  </div>

                  {/* Phone */}
                  <div>
                    <label className="block text-sm font-medium mb-1">
                      Candidate Phone No <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      name="CandidatePhoneNo"
                      maxLength="10"
                      placeholder="Candidate Phone No"
                      value={formData.CandidatePhoneNo}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^\d*$/.test(value)) {
                          handleChange(e);
                        }
                      }}
                      className="w-full px-4 py-2 border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
                    />
                    {errors.CandidatePhoneNo && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.CandidatePhoneNo}
                      </p>
                    )}
                  </div>

                  {/* PAN */}
                  <div>
                    <label className="block text-sm font-medium mb-1">
                      Candidate PAN
                    </label>
                    <input
                      type="text"
                      name="CandidatePAN"
                      placeholder="Candidate PAN"
                      value={formData.CandidatePAN}
                      onChange={handleChange}
                      className="w-full px-4 py-2 border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
                    />
                  </div>

                  {/* DOB */}
                  <div>
                    <label className="block text-sm font-medium mb-1">
                      Candidate DOB <span className="text-red-500">*</span>
                    </label>
                    <Flatpickr
                      value={formData.CandidateDOB}
                      onChange={(date) => {
                        handleChange({
                          target: {
                            name: "CandidateDOB",
                            value: date[0],
                          },
                        });
                      }}
                      options={{
                        dateFormat: "Y-m-d",
                        maxDate: "today",
                      }}
                      placeholder="yyyy-mm-dd"
                      className="w-full px-4 py-2 border rounded-md border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-300"
                    />
                    {errors.CandidateDOB && (
                      <p className="text-red-500 text-sm mt-1">
                        {errors.CandidateDOB}
                      </p>
                    )}
                  </div>

                  {/* Buttons */}
                  <div className="md:col-span-2 flex justify-center gap-6 mt-6">
                    <button
                      type="submit"
                      className="bg-primary text-white px-8 py-2 rounded-md"
                    >
                      Verify
                    </button>

                    <button
                      type="button"
                      onClick={handleReset}
                      className="bg-gray-200 px-8 py-2 rounded-md"
                    >
                      Reset
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <JobDescriptionModal
        show={showJDModal}
        onHide={() => setShowJDModal(false)}
        fullPath={jobDetails?.jobDescription}
      />

      {/* Tailwind Modal */}
      <SendCandidateModal
        show={showSendForm}
        onClose={() => setShowSendForm(false)}
        onSubmit={handleSendSubmit}
        sendFormData={sendFormData}
        handleSendChange={handleSendChange}
        errors={errors}
        gender={gender}
        joblocations = {joblocations}
      />

      {alert && (
        <NormalAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert(null)}
        />
      )}
      {showConfirm && confirmalert && (
        <ConfirmationAlert
          title={confirmalert.type}
          message={confirmalert.message}
          onClose={handleCancel}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
          highlightType={confirmalert.highlightType}
        />
      )}
    </>
  );
};

export default SubmitCandidate;
